// Giao diện (Quản lý / Bán hàng) cấp trên chọn cho Đại lý / CTV LÚC TẠO — docs/KE_HOACH_CHON_GIAO_DIEN_CAP_DUOI.md.
// Hai ô tick: bỏ được một, ô còn lại cuối cùng thì khoá. Tạo xong không sửa được. Dùng ở form tạo cấp dưới (Mạng lưới)
// và hộp tạo đơn vị của khu Quản trị NPP.

import { WORK_MODES, WORK_MODE_LABEL, type WorkMode } from '@shoptrack/common/unit-permissions'
import { cn } from '@/lib/utils'

export const ALL_WORK_MODES: WorkMode[] = [...WORK_MODES]

export function WorkModePicker({
  value,
  onChange,
  disabled,
  className,
}: {
  value: readonly WorkMode[]
  onChange: (next: WorkMode[]) => void
  disabled?: boolean
  className?: string
}) {
  const toggle = (m: WorkMode) => onChange(WORK_MODES.filter((x) => (x === m ? !value.includes(m) : value.includes(x))))
  return (
    <fieldset className={cn('space-y-1.5', className)}>
      <legend className="text-sm text-inkSoft">Giao diện</legend>
      <div className="flex flex-wrap gap-2">
        {WORK_MODES.map((m) => {
          const on = value.includes(m)
          const locked = disabled || (on && value.length === 1)
          return (
            <label
              key={m}
              className={cn(
                'flex min-h-11 items-center gap-2 rounded-lg border px-3 text-sm desktop:min-h-9',
                on ? 'border-accent/50 bg-accent/5 text-ink' : 'border-rule bg-paper text-inkSoft',
                locked ? 'cursor-default' : 'cursor-pointer',
              )}
            >
              <input
                type="checkbox"
                className="size-4 shrink-0 cursor-pointer accent-accent disabled:cursor-default"
                checked={on}
                disabled={locked}
                onChange={() => toggle(m)}
              />
              {WORK_MODE_LABEL[m]}
            </label>
          )
        })}
      </div>
    </fieldset>
  )
}
